import { makeApiRequest } from 'actions/api';
import RequestService from 'services/RequestService';

export const GET_USER_OFFER = 'GET_USER_OFFER';
export const GET_USER_OFFER_REQUEST = 'GET_USER_OFFER_REQUEST';
export const GET_USER_OFFER_RESPONSE = 'GET_USER_OFFER_RESPONSE';
export const GET_USER_OFFER_ERROR = 'GET_USER_OFFER_ERROR';

export const CLAIM_USER_OFFER = 'CLAIM_USER_OFFER';
export const CLAIM_USER_OFFER_REQUEST = 'CLAIM_USER_OFFER_REQUEST';
export const CLAIM_USER_OFFER_RESPONSE = 'CLAIM_USER_OFFER_RESPONSE';
export const CLAIM_USER_OFFER_ERROR = 'CLAIM_USER_OFFER_ERROR';

export const getUserOffer = eventType =>
  makeApiRequest({
    requestType: GET_USER_OFFER,
    method: RequestService.getUserOffer,
    params: { eventType },
  });

export const claimUserOffer = userOfferHashId =>
  makeApiRequest({
    requestType: CLAIM_USER_OFFER,
    method: RequestService.claimUserOffer,
    params: { userOfferHashId },
  });
